export enum DieboardType {
    FixedSize = 'FixedSize',
    RotaryFixedSize = 'RotaryFixedSize',
    RotaryAutoSize = 'RotaryAutoSize',
    AutoSize = 'AutoSize'
}
